import clsx from 'clsx';
import type { ReactNode } from 'react';

interface SecurityCardProps {
  title: string;
  badge?: ReactNode;
  description: ReactNode;
  /** Shown but out of reach: two-factor without a password has nothing to guard. */
  isDimmed?: boolean;
  children: ReactNode;
}

/** One card on the Security tab: a heading with its state, what it means, and its rows or actions. */
export function SecurityCard({ title, badge, description, isDimmed = false, children }: SecurityCardProps) {
  return (
    <section aria-label={title} className="rounded-lg border border-line bg-surface p-5">
      <div className="flex flex-wrap items-center gap-2">
        <h2 className="text-base font-semibold text-fg">{title}</h2>
        {badge}
      </div>
      <div className="mt-1 text-sm text-muted">{description}</div>
      <div className={clsx(isDimmed && 'opacity-60')}>{children}</div>
    </section>
  );
}
